import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0057',
    ecrans: ['00-2']
});
